var pug = require("!../../node_modules/.pnpm/pug@3.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Boolean, action, bgColor, direction, hoverOffset, label, offset, rotate, size, url, x) {
      const styleParts = [size != null && `--ccm-item-size:${size}`, rotate != null && `--ccm-item-deg:${rotate}`, x != null && `--ccm-item-x:${x}`, offset != null && `--ccm-item-offset:${offset}`, hoverOffset != null && `--ccm-item-hover-offset:${hoverOffset}`, bgColor != null && `--ccm-item-bg-color:${bgColor}`].filter(Boolean).join(';')
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([`ccm-items ${direction}`], [true]), false, true)+pug.attr("onclick", action, true, true)+pug.attr("style", pug.style(styleParts), true, true)) + "\u003E";
if (url) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", url, true, true)+" rel=\"noopener noreferrer\"") + "\u003E" + (pug.escape(null == (pug_interp = label) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = label) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
    }.call(this, "Boolean" in locals_for_with ?
        locals_for_with.Boolean :
        typeof Boolean !== 'undefined' ? Boolean : undefined, "action" in locals_for_with ?
        locals_for_with.action :
        typeof action !== 'undefined' ? action : undefined, "bgColor" in locals_for_with ?
        locals_for_with.bgColor :
        typeof bgColor !== 'undefined' ? bgColor : undefined, "direction" in locals_for_with ?
        locals_for_with.direction :
        typeof direction !== 'undefined' ? direction : undefined, "hoverOffset" in locals_for_with ?
        locals_for_with.hoverOffset :
        typeof hoverOffset !== 'undefined' ? hoverOffset : undefined, "label" in locals_for_with ?
        locals_for_with.label :
        typeof label !== 'undefined' ? label : undefined, "offset" in locals_for_with ?
        locals_for_with.offset :
        typeof offset !== 'undefined' ? offset : undefined, "rotate" in locals_for_with ?
        locals_for_with.rotate :
        typeof rotate !== 'undefined' ? rotate : undefined, "size" in locals_for_with ?
        locals_for_with.size :
        typeof size !== 'undefined' ? size : undefined, "url" in locals_for_with ?
        locals_for_with.url :
        typeof url !== 'undefined' ? url : undefined, "x" in locals_for_with ?
        locals_for_with.x :
        typeof x !== 'undefined' ? x : undefined));
    ;;return pug_html;};
module.exports = template;